import { Empresa } from "./Empresa.ts";

export class Usuario {
  id: number;
  email: string;
  senha: string;
  telefone: string;
  empresas: Empresa[];

  constructor(dados: any) {
    this.id = dados.id;
    this.email = dados.email;
    this.senha = dados.senha;
    this.telefone = dados.telefone;
    this.empresas = dados.empresas
      ? dados.empresas.map((emp: any) => new Empresa(emp))
      : [];
  }
}
